import type { Favorite, FileCreateRequest, FileStatusEnum } from '@openapi'
import type { RecentFile } from '@lib/types/recentFiles.types'
import type { CompactFile, CompactFolder } from '@browser/stores/api'

export interface DeviceFileCreateRequest extends Omit<FileCreateRequest, 'content'> {
  path: string
}

export type AllFileCreateRequest = FileCreateRequest | DeviceFileCreateRequest

export enum ViewCompactItemType {
  File = 'file',
  Folder = 'folder',
  SmartFolder = 'smart_folder',
}

export type ViewCompactFile = Omit<CompactFile, 'created_by'> & {
  type: ViewCompactItemType.File
  favoriteId?: Favorite['id']
  createdBy: string
  content_type?: string
}

export type ViewCompactFolder = Omit<CompactFolder, 'created_by'> & {
  type: ViewCompactItemType.Folder
  favoriteId?: Favorite['id']
  content_type?: null
  thubmnail_url?: null
  file_thumbnail_urls?: string[]
  folders_count?: number
  files_count?: number
  available_folders_count?: number
  available_files_count?: number
  status?: string
}

export interface DeviceFile {
  name: string
  type: string
  path: string
  size: number
}

export type ViewCompactFileFolder = ViewCompactFolder | ViewCompactFile

export type RenderableFile =
  | (Favorite & { thumbnail_url?: string; file_thumbnail_urls?: string[]; status?: FileStatusEnum })
  | RecentFile
  | ViewCompactFileFolder
